<div class="white-bg">
  <breadcrumbs>
    <breadcrumb route="/" [label]="'Dashboard' | translate | async"></breadcrumb>
    <breadcrumb [currentRoute]="true" [label]="'Thermography Inspection' | translate | async"></breadcrumb>
  </breadcrumbs>
  <div class="content">
    <div class="overview">
      <div class="overview__image-container">
        <div class="overview__image" *ngIf="!loadingEquipment" [style.width.px]="size" [@fadeIn]>
          <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" />
        </div>
      </div>
      <div class="overview__content">
        <div class="content__primary">
          <item-group>
            <item [label]="translate('Serial Number')" [primary]="true" [loading]="loadingEquipment">
              <a routerLink="/equipment/{{equipmentId}}"
                [matTooltip]="translate('Manage Equipment')">{{ equipmentDetails.SerialNumber }}</a>
            </item>
            <item [label]="translate('Unit Number')" [primary]="true" [loading]="loadingEquipment">
              <a routerLink="/equipment/{{equipmentId}}"
                [matTooltip]="translate('Manage Equipment')">{{ equipmentDetails.UnitNumber }}</a>
            </item>

            <item [label]="translate('Additional Unit Number')" [primary]="true" [loading]="loadingEquipment" *ngIf="equipmentDetails.AdditionalUnitNo!=null">
             {{ equipmentDetails.AdditionalUnitNo }}
            </item>
            <!--
              <item [label]="translate('Make')" [loading]="overviewIsLoading">{{overviewModel.Equipment.Make}}</item>
              <item [label]="translate('Model')" [loading]="overviewIsLoading">{{overviewModel.Equipment.Model}}</item>
            -->
          </item-group>
          <div class="content__primary-buttons" *ngIf="!loadingEquipment" [@fadeInList]>
            <button mat-raised-button color="warn" *ngIf="!IsRelease"
              [matTooltip]="translate('Release Report to Customer')" (click)="releaseReport()"
              [class.loading]="releasing">{{translate('Release')}}</button>

            <a class="button waves-effect" target="_blank"  *ngIf="IsRelease"
              href="/api/ThermographyInspection/GetThermogarphyInspectionPDF?inspectionId={{inspectionId}}&equipmentId={{equipmentId}}">
              <i class="material-icons button__icon">save_alt</i>
              <span class="button__text">{{translate('PDF')}}</span>
            </a>
          </div>
        </div>
        <div class="content__secondary">
          <div class="special">
            <item-group>
              <div>
                <item [label]="translate('Customer')" [loading]="loadingEquipment">{{ equipmentDetails.CustomerName }}
                </item>
              </div>
              <div>
                <item [label]="translate('Job Site')" [loading]="loadingEquipment">{{ equipmentDetails.JobsiteName }}
                </item>
              </div>
              <div>
                <item [label]="translate('Meter Reading (SMU/Hourmeter)')" [loading]="loadingEquipment">
                  {{ equipmentDetails.Smu }}</item>
              </div>
              <div>
                <item [label]="translate('Life to Date (LTD)')" [loading]="loadingEquipment">{{ equipmentDetails.Ltd }}
                </item>
              </div>
              <div>
                <item [label]="translate('Make')" [loading]="loadingEquipment">{{ equipmentDetails.Make }}</item>
              </div>
              <div>
                <item [label]="translate('Model')" [loading]="loadingEquipment">{{ equipmentDetails.Model }}</item>
              </div>
              <div>
                <item [label]="translate('Family')" [loading]="loadingEquipment">{{ equipmentDetails.Family }}</item>
              </div>
              <div></div>
            </item-group>
          </div>

        </div>

        <div style="display: flex; flex-direction: row;justify-content: space-evenly;margin-top: 2%;">
          <div class="input-grouping">
            <span class="input-grouping__side_1">{{ "Inspection Date *" | translate | async }}</span>
            <span>
              <input class="input-travel" min="{{equipmentDetails?.EquipmentSetupDate | date:'yyyy-MM-dd'}}"
                (click)="picker.open()" readonly [matDatepicker]="picker" placeholder="Choose a date" [(ngModel)]="InspectionDate" 
                (dateChange)="UpdateInspectionDate($event)"
                max="{{ todate | date:'yyyy-MM-dd'}}" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </span>
          </div>

          <div class="input-grouping">
            <span class="input-grouping__side_1">{{"Meter Reading(SMU/Hourmeter) * " | translate | async }}</span>
            <span >
              <input class="input-travel inspectionSMUInput" type="number" [(ngModel)]="smu" (focusout)="UpdateSMU()"/> Hrs
            </span>
          </div>

        </div>
      </div>
    </div>
  </div>

  <hr>

  <div>
    <div style=" height: 150px;display: flex;flex-direction: row;">
      <span class="inspection-notes-label">
        {{ "Overall Inspection Comment" | translate | async }}
      </span>
      <!-- <span>
        <textarea class="inspection-notes-textArea" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"   ></textarea>
      </span> -->
      <span style="width: 85%;  margin-left: 1%;">
      <edit-data  inputId="interpretationComment" dataType="textarea" 
      [canEdit]="true" [(value)]="comment"
      (valueChanged)="updateInspectionComment($event)"></edit-data>
    </span>
      
    </div>
  </div>

  <div>
    <!-- <app-insp-system  [FamilyImage_Frame]="FamilyImage_Frame"  [FamilyImage_Chain]="FamilyImage_Chain"></app-insp-system> -->

    <!--Framesssss-->
    <div class="flex flex-containers" >
      <div class="panel info-panels ">
        
        <div *ngIf="Loadall">
          <app-insp-system   [side]="1" [systemType] ="2" [FrameSystem_L] ="LeftFrame" [SerialNo]="SerialF_l"
          [FamilyImage_Frame]="FamilyImage_Frame"></app-insp-system> 
        </div>
      </div>

      <div class="panel  info-panels">
        
        <div *ngIf="Loadall">
          <app-insp-system  [side]="2" [systemType] ="2"  [FrameSystem_R] ="RightFrame"  [SerialNo]="SerialF_r"
          [FamilyImage_Frame]="FamilyImage_Frame"></app-insp-system>
        </div>
    </div>
  </div>
    
<!--Chainsssss-->
  <div class="flex flex-containers" >
    <div class="panel info-panels ">
      
      <div *ngIf="Loadall">
        <app-insp-system  [side]="1" [systemType] ="1"   [ChainSystem_L]="LeftChain" [SerialNo]="SerialC_l" [tracksag_L]="tracksag_l"  [chain_CMU]="chain_CMU_l"
        [FamilyImage_Chain]="FamilyImage_Chain"></app-insp-system>
      </div>
    </div>

    <div class="panel  info-panels" >
      
      <div *ngIf="Loadall">
        <app-insp-system  [side]="2" [systemType] ="1"   [ChainSystem_R]="RightChain" [SerialNo]="SerialC_r" [tracksag_R]="tracksag_r" [chain_CMU]="chain_CMU_r"
        [FamilyImage_Chain]="FamilyImage_Chain"></app-insp-system>
      </div>
  </div>
</div>

<!--Additionalsssss-->
<div class="flex flex-containers" style="margin-bottom: 12%;" >
  <div class="panel info-panels ">
  
    <div *ngIf="Loadall">
      <app-insp-system [side]="1" [systemType]="0" [AdditionalSys_L]="LeftAdditional" ></app-insp-system>
    </div>
  </div>
  
  <div class="panel  info-panels">
  
    <div *ngIf="Loadall">
      <app-insp-system [side]="0" [systemType]="0" [AdditionalSys_N]="NoSideAdditional"  ></app-insp-system>
    </div>
  </div>

  <div class="panel  info-panels">
  
    <div *ngIf="Loadall">
      <app-insp-system [side]="2" [systemType]="0" [AdditionalSys_R]="RightAdditional"  ></app-insp-system>
    </div>
  </div>

</div>

   

     

    
  </div>

</div>